import { Avatar, Box, Tooltip, Typography } from '@mui/material';
import { Column } from 'react-data-grid';
import DateFormat from '../../elements/Date/DateFormat';
import { AuditLog } from '@oxappsec/ox-unified-audit-logger';
import {
  getLogDisplayName,
  resolveLogNameIcon,
  resolveLogTypeIcon,
} from '../utils/audit-log-utils';
import AdditionalInfoSwitcher from '../components/AdditionalInfo/AdditionalInfoSwitcher';
import { useRef } from 'react';

export const useAuditLogsHeader = (classes?: { headerCell?: string }) => {
  const baseColumn: Partial<Column<AuditLog>> = {
    headerCellClass: classes?.headerCell,
  };

  const columnsRef = useRef<Column<AuditLog>[]>([
    {
      ...baseColumn,
      key: 'userEmail',
      name: 'User',
      minWidth: 140,
      formatter: ({ row }) => (
        <Tooltip title={row.userId}>
          <Box display='flex' flexDirection='row' alignItems='center' gap={1}>
            <Avatar
              alt={row.userEmail}
              src={row.userEmail}
              sx={{ width: 24, height: 24 }}
            />
            <Typography variant='body2' color='text.primary'>
              {row.userEmail}
            </Typography>
          </Box>
        </Tooltip>
      ),
    },
    {
      ...baseColumn,
      key: 'logName',
      name: 'Action',
      minWidth: 160,
      formatter: ({ row }) => (
        <Box display='flex' flexDirection='row' alignItems='center' gap={1}>
          {resolveLogNameIcon(row.logName)}
          <Typography variant='body2' color='text.primary'>
            {getLogDisplayName(row.logName)}
          </Typography>
        </Box>
      ),
    },
    {
      ...baseColumn,
      key: 'additionalInfo',
      name: 'Additional Info',
      minWidth: 300,
      formatter: ({ row }) => (
        <Box display='flex' flexDirection='column' gap={1}>
          <AdditionalInfoSwitcher auditLog={row} />
        </Box>
      ),
    },
    {
      ...baseColumn,
      key: 'logType',
      name: 'Log Type',
      minWidth: 160,
      formatter: ({ row }) => (
        <Box display='flex' flexDirection='row' alignItems='center' gap={1}>
          {resolveLogTypeIcon(row.logType)}
          <Typography variant='body2' color='text.primary'>
            {row.logType}
          </Typography>
        </Box>
      ),
    },
    {
      ...baseColumn,
      key: 'date',
      name: 'Date',
      minWidth: 160,
      formatter: ({ row }) => {
        return <DateFormat date={new Date(row.date)} />;
      },
    },
  ]);

  return columnsRef.current;
};
